import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import GuestGuard from 'utils/route-guard/GuestGuard';

// maintenance routing
const MaintenanceError = Loadable(lazy(() => import('views/pages/maintenance/Error')));
const MaintenanceError500 = Loadable(lazy(() => import('views/pages/maintenance/Error500')));
const MaintenanceComingSoon1 = Loadable(lazy(() => import('views/pages/maintenance/ComingSoon/ComingSoon1')));
const MaintenanceComingSoon2 = Loadable(lazy(() => import('views/pages/maintenance/ComingSoon/ComingSoon2')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));

const Terms = Loadable(lazy(() => import('views/pages/Termscondition')));
const Betrules = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));
const Responsiblegaming = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));
const Privacypolicy = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));
const Aboutus = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));
// const Contactus = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));
const Locations = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));
const Contactus = Loadable(lazy(() => import('views/pages/contact/contactus')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/pages/error',
            element: <MaintenanceError />
        },
        {
            path: '/pages/500',
            element: <MaintenanceError500 />
        },
        {
            path: '/pages/coming-soon1',
            element: <MaintenanceComingSoon1 />
        },
        {
            path: '/pages/coming-soon2',
            element: <MaintenanceComingSoon2 />
        },
        {
            path: '/pages/under-construction',
            element: <MaintenanceUnderConstruction />
        },

        // Footer.
        { path: 'terms', element: <Terms /> },
        { path: 'betrules', element: <Betrules /> },
        { path: 'responsiblegaming', element: <Responsiblegaming /> },
        { path: 'privacypolicy', element: <Privacypolicy /> },
        { path: 'aboutus', element: <Aboutus /> },
        { path: 'contactus', element: <Contactus /> },
        { path: 'locations', element: <Locations /> }
    ]
};

export default AuthenticationRoutes;
